export default "/credits/business/assets/1666949f1c93e33346e0df5c8c9cf8bd.png";